<div class="grid grid-cols-12 gap-8">
    
    <div class="col-span-12 lg:col-span-6 xl:col-span-6">
        <div class="card flex flex-col items-center">
            <div class="font-semibold text-xl mb-4">Répartition des stocks par état</div>
            <p-chart type="doughnut" [data]="chartEtatData" [options]="chartEtatOptions" width="100%" height="200px"></p-chart>
        </div>
    </div>

    <div class="col-span-12 lg:col-span-6 xl:col-span-6">
        <div class="card flex flex-col items-center">
            <div class="font-semibold text-xl mb-4">Répartition des stocks dans l'entrepôt</div>
            <p-chart type="bar" [data]="chartSecteurData" [options]="chartSecteurOptions" width="100%" height="200px"></p-chart>
        </div>
    </div>

    <div class="col-span-12 sm:col-span-6 2xl:col-span-3">
        <div class="card relative mb-0 overflow-hidden">
            <div class="absolute top-16 -right-4">
                <i class="pi pi-qrcode text-blue-500 !text-9xl"></i>
            </div>
            <div class="flex justify-between mb-4">
                <div>
                    <span class="block text-muted-color font-medium text-xl mb-4">Nombre de références distinctes</span>
                    <div class="text-surface-900 dark:text-surface-0 font-medium text-3xl">{{ nbReferences }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-span-12 sm:col-span-6 2xl:col-span-3">
        <div class="card relative mb-0 overflow-hidden">
            <div class="absolute top-16 -right-4">
                <i class="pi pi-inbox text-purple-500 !text-9xl"></i>
            </div>
            <div class="flex justify-between mb-4">
                <div>
                    <span class="block text-muted-color font-medium text-xl mb-4">Nombre de stocks dans l'entrepôt</span>
                    <div class="text-surface-900 dark:text-surface-0 font-medium text-3xl">{{ nbStocks }}</div>
                </div>
            </div>
        </div>
    </div>
</div>